import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { getSessionData } from "../../../base/helper/baseHelper";
import {
  GetSupplierEdiCodeWithoutManupulation,
  getSuppliers,
} from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";

import SelectableSearch from "../../../base/views/SelectableSearch";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";

const fileToArrayBuffer = require("file-to-array-buffer");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  formControl: {
    width: "20%",
  },
  form: {
    display: "flex",
    justifyContent: "space-between",
  },
  showpath: {
    padding: "0.5rem",
    marginRight: "1rem",
  },
  button: {
    marginRight: "1rem",
  },
  reconsile: {
    display: "flex",
    justifyContent: "flex-end",
  },
  comingSoon : {
    fontSize : "2rem",
    textAlign : "center"
  }
}));

const initialStateValues = {
  selectedSupplier: { id: 0, optionname: "" },
  selectedFile: null,
  selectedFileName: null,
  tote_number: "",
  ra_number: "",
};

function CreditMemo(props) {
  const classes = useStyles();
  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [errors, setErrors] = React.useState({});
  const [creditMemoState, setCreditMemoState] = useState(
    initialStateValues
  );
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [supplierCodeData, setSupplierCodeData] = useState([]);

  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setUserId(getSessionData({ key: "userId" }));
    setStoreId(store.storeid);
  }, [storeId]);

  useEffect(() => {
    GetSupplierEdiCodeWithoutManupulation().then((response) => {
      setSupplierCodeData(response);
    });
  }, []);

  const validateSA = (fieldValues = creditMemoState) => {
    let temp = { ...errors };

    if ("selectedSupplier" in fieldValues) {
      temp.selectedSupplier =
        fieldValues.selectedSupplier.optionname === ""
          ? "Supplier is required"
          : "";
    }

    if ("selectedFile" in fieldValues) {
      temp.selectedFile =
        fieldValues.selectedFile === null ? "No file selected" : "";
    }

    if ("selectedFileName" in fieldValues) {
      temp.selectedFileName =
        fieldValues.selectedFileName === null ? "No file selected" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  function toBuffer(arrayBuffer) {
    var bufferData = Buffer.alloc(arrayBuffer.byteLength);
    var view = new Uint8Array(arrayBuffer);
    for (var i = 0; i < bufferData.length; ++i) {
      bufferData[i] = view[i];
    }
    return bufferData;
  }

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const fileName = e.target.files[0].name;
      fileToArrayBuffer(e.target.files[0]).then((data) => {
        const buffer = toBuffer(data);
        setCreditMemoState({
          ...creditMemoState,
          selectedFile: buffer,
          selectedFileName: fileName,
        });
      });
    }
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      let sc = supplierCodeData.filter((item) => {
        return item.suppliername === value.optionname.split("-")[0];
      });
      setCreditMemoState({
        ...creditMemoState,
        selectedSupplier: { id: value.id, optionname: value.optionname },
        suppliercode: sc.length ? sc[0].suppliercode : "",
      });
    } else {
        setCreditMemoState({
        ...creditMemoState,
        selectedSupplier: {},
      });
    }
  };

  const handleSASubmit = async (e) => {
    e.preventDefault();
    if (validateSA()) {
      const formData = new FormData();
      formData.append("data", JSON.stringify(creditMemoState.selectedFile));
      formData.append("store", storeId);
      formData.append(
        "supplier_name",
        creditMemoState.selectedSupplier.optionname
      );
      var dateString = new Date()
        .toISOString()
        .replace(/T/, "_")
        .replace(/:/g, "_")
        .replace(/-/g, "_")
        .replace(/\./, "_");
      dateString = dateString.substring(0, dateString.length - 1);
      var fileName = creditMemoState.selectedFileName + "_" + dateString;
      formData.append("filename", fileName);
      formData.append("userId", userId);
    }
  };

  return (
    <>
      <div className={classes.comingSoon}>
        <div>We will come soon</div>
      </div>
      <div style={{ pointerEvents : "none", opacity : "0.3"}}>
      <Container maxWidth="lg" className={classes.container}>
        <div style={{ width: "33.3%" }}>
          <SelectableSearch
              autoFocus
              value={creditMemoState.selectedSupplier}
              data={supplierData}
              name="supplier"
              label="Supplier"
              id="supplier"
              loading={loadSupplierDropdown}
              onChangeEvent={handleSupplierChange}
              variantType="standard"
              {...(errors.selectedSupplier && {
                error: true,
                helperText: errors.selectedSupplier,
              })}
            ></SelectableSearch>
        </div>
        <form onSubmit={handleSASubmit} className={classes.form}>
          <div className={classes.showpath}>
            {creditMemoState.selectedFileName ? (
              <p>{creditMemoState.selectedFileName}</p>
            ) : errors.selectedFile ? (
              <p style={{ color: "red" }}>No file choosen</p>
            ) : (
              <p>No file choosen</p>
            )}
          </div>
          <label htmlFor="contained-button-file">
            <input
              accept="810/*"
              id="contained-button-file"
              type="file"
              style={{ display: "none" }}
              onChange={(e) => {
                handleFileChange(e);
              }}
            />
            <Button
              variant="contained"
              className={classes.button}
              startIcon={<CloudUploadIcon />}
              component="span"
            >
              Upload
            </Button>
          </label>
          <div>
            <Button fullWidth variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </Container>
      <div className={classes.root}>
        <MaterialTable
          title=""
          columns={[
            { title: "CM#", field: "creditmemono"},
            { title: "RA#", field: "returnauthorizationno"},
            { title: "NDC/UPC", field: "ndc" },
            { title: "Quantity", field: "quantity" },
            { title: "Description", field: "description" },
            { title: "UOM", field: "uom" },
            { title: "RC Description", field: "rcd" },
            { title: "Invoice Number", field: "invoiceno" },
            { title: "Invoice Date", field: "invoicedate" },
            { title: "Credit", field: "credit" },
          ]}
          options={{
            exportButton: true,
            exportAllData: true,
            maxBodyHeight: 400,
            paging: true,
            pageSize: 25,
            pageSizeOptions: [25, 50, 100],
            headerStyle: {
              backgroundColor: "rgba(255,255,255,1)",
              color: "black",
            },
          }}
        />
      </div>
      <LandingPageFooter />
    </div>
    </>
  );
}

export default CreditMemo;
